import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Checkbox from '@material-ui/core/Checkbox'
import Content from 'components/shared/Content'
import { toTitleCase, normaliseID, normaliseIDwithZero } from 'utils/common'
import { ITank } from 'types'

const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

interface IProps {
  device: ITank,
  materialName: any
}

const ViewMode = ({ device, materialName }: IProps): React.ReactElement => (
  <Grid container direction="column">
    <Grid item>
      <Content style={style} label="Device ID" value={normaliseID(device.deviceID)} />
    </Grid>
    <Grid item>
      <Content style={style} label="Tank ID" value={normaliseID(device.tankId)} />
    </Grid>
    <Grid item>
      <Content style={style} label="Ship To" value={normaliseIDwithZero(device.sh)} />
    </Grid>
    <Grid item>
      <Content style={style} label="Country" value={toTitleCase(device.country)} />
    </Grid>
    {device.zone == 'Not Available' ? (<Grid item>
      <Content style={style} label="Zone" value='' />
    </Grid>) :
      (<Grid item>
        <Content style={style} label="Zone" value={toTitleCase(device.zone)} />
      </Grid>)
    }
    <Grid item>
      <Content style={style} label="Status" value={toTitleCase(device.status)} />
    </Grid>
    <Grid item>
      <Content style={style} label="Product" value={toTitleCase(device.product)} />
    </Grid>
    <Grid item>
      <Content style={style} label="Material#" value={toTitleCase(device.productcode)} />
    </Grid>
    {(device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && (<Grid item>
      <Content style={style} label="Material Name" value={materialName !== undefined ? materialName.toString() : ''} />
    </Grid>)}
    {(device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && (<Grid item>
      <Content style={style} label="Quantity" value={device.quantity !== undefined ? device.quantity.toString() : ''} />
    </Grid>)}
    {(device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER') && (<Grid item>
      <Content style={style} label="Pressure" value={device.pvalue !== undefined ? device.pvalue.toString() : ''} />
    </Grid>)}
    {(device.type.toString().indexOf('manifold') === -1 && device.type.toString().toUpperCase() !== 'BLEREADER') && (<Grid item>
      <Content style={style} label="Capacity" value={device.capacity !== undefined ? device.capacity.toString() + ' ' + device.info.uom : ''} /> 
    </Grid>)}
    <Grid item>
      <Content style={style} label="Name" value={toTitleCase(device.name)} />
    </Grid>

    <Grid item>
      <Content style={style} label="Suburb" value={toTitleCase(device.suburb)} />
    </Grid>
    <Grid item>
      <Content style={style} label="Type" value={device.type === 'blereader' ? 'BLE Reader' : toTitleCase(device.type)} />
    </Grid>

    <Grid item>
      <Content style={style} label="Address" value={toTitleCase(device.street)} />
    </Grid>
    <Grid container alignItems="baseline" style={{ padding: '4px 0', ...style }}>
      <Grid item xs={5}>
        <Typography variant="h4">EDI Setup</Typography>
      </Grid>
      <Grid item xs={7}>
        <Checkbox disabled checked={device.edisetup} />
      </Grid>
    </Grid>
  </Grid>
)

export default ViewMode
